import React from "react";
import { dispatchTrackingEvent } from "src/utils/analytics";
import { mapFilterStateChangeToLegacyEventValues as mapFilterStateChangeToLegacyEvents } from "src/utils/analytics/legacyMappings";

export type UseSearchAnalyticsReturnValues = {
  onSearchStateChange: (updatedSearchState, searchState) => void;
};

const debouncedFilterKeys = ["query"];

const splitDebouncedEvents = (events) =>
  events.reduce(
    (result, event) =>
      debouncedFilterKeys.includes(event.filterKey)
        ? { ...result, debounce: [...result.debounce, event] }
        : { ...result, fireNow: [...result.fireNow, event] },
    { fireNow: [], debounce: [] }
  );

const dispatchTrackingEvents = (eventName: string, events) => {
  for (const event of events)
    dispatchTrackingEvent(eventName, {
      value: event.value
    });
};

export default function useSearchAnalytics(
  eventName: string,
  onSearchStateChange?: (searchState) => void
): UseSearchAnalyticsReturnValues {
  const [debounceTimeout, setDebounceTimeout] = React.useState<
    NodeJS.Timeout | undefined
  >(undefined);

  const extendedOnSearchStateChange = (state, prevState) => {
    const events = splitDebouncedEvents(
      mapFilterStateChangeToLegacyEvents(state, prevState)
    );

    dispatchTrackingEvents(eventName, events.fireNow);

    if (events.debounce.length) {
      if (debounceTimeout) clearTimeout(debounceTimeout);
      setDebounceTimeout(
        setTimeout(() => {
          dispatchTrackingEvents(eventName, events.debounce);
        }, 400)
      );
    }

    if (!onSearchStateChange) return;
    onSearchStateChange(state);
  };

  return {
    onSearchStateChange: extendedOnSearchStateChange
  };
}
